export const SliderTypes = {

    COMPLEMENTARY_ARTICLES: 'sw',
    DEFAULT: 'reco',
    SOLD_OUT: 'aa',
    OUTFIT: 'go',
    PRODUCT_SERIES: 'mm',
    SHOP_THE_LOOK: 'stl',
    OUTFITS: 'outfits'
};
